module.exports = __webpack_public_path__ + "img/godady.2fb36772.png";